// src/data/disciplineStorage.js
//
// RULINGS 187 + 190 (Bob, 2026-09-19). A discipline case and everything attached to it are seen only by those
// directly involved: the member named in it, the Local Chairperson of that territory, the General Chairperson
// of that committee - plus whoever opened the case (every file is tagged with the case's creator, P-5), and the administrator. "#41 should not be able to
// freely review anything in 342."
//
// The case RECORD already obeys that (firestore.rules, match /disciplineCases). The ATTACHMENTS did not:
// storage.rules let any officer on any committee read them. Storage rules cannot read Firestore, so the
// case's scope travels WITH each file as custom metadata, written at upload from this one function, and
// storage.rules compares it with the reader's token - the pattern ruling 74 proved on claims.
//
// Pure. Read by src\pages\DisciplineCases.js at every upload; proved by scripts\test-discipline-storage.mjs;
// the rule it feeds is proved by scripts\test-storage-rules.mjs.

// The tag for a file on this case, or undefined when the case lacks what EVERY tag must carry (who opened
// it, and which committee) - storage.rules refuses an upload without those two, so an untagged file cannot
// be created. The territory and the member are carried when the case has them; a file without them is
// simply not readable by an LC or member arm (never readable by more people than the case).
export function disciplineObjectTag(kase) {
  const k = kase || {};
  const s = (v) => (typeof v === 'string' ? v.trim() : v == null ? '' : String(v).trim());
  const createdBy = s(k.createdBy);
  const committee = s(k.generalCommittee);
  if (!createdBy || !committee) return undefined;
  const md = { createdBy, committee };
  if (s(k.scopeKey)) md.scopeKey = s(k.scopeKey);
  if (s(k.memberUid)) md.memberUid = s(k.memberUid);
  if (s(k.memberEmail)) md.memberEmail = s(k.memberEmail);   // compared as the case rule compares it (ruling 176): as stored
  return { customMetadata: md };
}

// The parties storage.rules admits for a discipline file - the same five the case rule admits. Exported so
// the verifier can hold the two rules to the same list.
export const DISCIPLINE_FILE_READERS = Object.freeze(['admin', 'case creator', 'named member', 'Local Chairperson of the territory', 'General Chairperson of the committee']);
